import { memo } from 'react';
import { MultiplierT } from './slotConstants';

// element render twice to be visible
// frame that renders first - above second because of SVG render priority
// but second frame is clickable because of z-index of foreign objects
// to prevent double click isClickable passed
type BottomScreenProps = {
  isClickable?: boolean
  isAnimating: boolean
  multiplier: MultiplierT
  onMultiplierClick: () => void
  isSafari: boolean
}
function BottomScreen({
  isClickable, multiplier, onMultiplierClick, isAnimating, isSafari,
}: BottomScreenProps) {
  const handleClick = () => {
    const animatedPath = document.getElementById('multiply-bnt');
    const container = document.getElementById('animation-container');
    const animation1 = document.getElementById('bnt-animation-1');
    const animation2 = document.getElementById('bnt-animation-2');
    const animation3 = document.getElementById('bnt-animation-3');

    if (animation1 && animation2 && animation3 && animatedPath) {
      (animation1 as unknown as SVGAnimateTransformElement).beginElement();
      (animation2 as unknown as SVGAnimateTransformElement).beginElement();
      (animation3 as unknown as SVGAnimateTransformElement).beginElement();
      setTimeout(() => {
        (animation1 as unknown as SVGAnimateTransformElement).endElement();
        (animation2 as unknown as SVGAnimateTransformElement).endElement();
        (animation3 as unknown as SVGAnimateTransformElement).endElement();
      }, 1000);
    }

    if (animatedPath && !isAnimating && container) {
      onMultiplierClick();
      container.append(animatedPath);
    }
  };
  return (
    <div
      className="h-full w-full z-[99] min-h-[20px] bg-transparent"
      id={isClickable ? 'slot-multiply-button-click' : 'slot-multiply-button'}
      onClick={() => {
        if (isClickable && !isAnimating) {
          handleClick();
        }
      }}
    >
      <div
        className="font-Russo h-full w-full flex items-center justify-center font-bold text-sm text-[#071573] bg-transparent"
        id={!isClickable ? 'animation-container' : ''}
      >
        {!isClickable && <BottomScreenSVG multiplier={multiplier} isSafari={isSafari} /> }
      </div>
    </div>
  );
}

export default memo(BottomScreen);

const BottomScreenSVG = memo(({ multiplier, isSafari }: {multiplier: number | string, isSafari: boolean}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="28px"
    width="100%"
    viewBox={isSafari ? '2 1 137 40' : '2 -2 137 42'}
    overflow="hidden"
    preserveAspectRatio="none"
    id="multiply-bnt"
    className="multiply-bnt"
  >
    <defs>
      <clipPath id="eaf-2661-1">
        <rect x="0" y="0" width="135" height="36" />
      </clipPath>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        x1="68.1015"
        y1="49.2524"
        x2="53.8945"
        y2="-7.6517"
        id="eaf-2661-2"
      >
        <stop stopColor="#cedff8" offset="0" />
        <stop stopColor="#e3edfb" offset="0.1885" />
        <stop stopColor="#f3f7fd" offset="0.4034" />
        <stop stopColor="#fcfdff" offset="0.6483" />
        <stop stopColor="#fff" offset="0.9856" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        x1="1.7121"
        y1="26.0654"
        x2="116.909"
        y2="-78.561"
        id="eaf-2661-3"
      >
        <stop stopColor="#dc83ff" offset="0" />
        <stop stopColor="#000296" offset="0.34" />
      </linearGradient>
      <radialGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-0.7851 0.6194 -1.2731 -1.6135 143.7806 18.8512)"
        cx="64.5"
        cy="22.5"
        r="54.4063"
        fx="64.5"
        fy="22.5"
        fr="0"
        id="eaf-2661-4"
      >
        <stop stopColor="#400538" offset="0" />
        <stop stopColor="#fff0" offset="1" />
      </radialGradient>
      <radialGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0.8875 -0.4608 0.7604 1.4645 -20.2953 -4.9486)"
        cx="19"
        cy="29.5"
        r="87.8877"
        fx="19"
        fy="29.5"
        fr="0"
        id="eaf-2661-5"
      >
        <stop stopColor="#fff0" offset="0" />
        <stop stopColor="#ff00c833" offset="1" />
      </radialGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        x1="67.7051"
        y1="10.3921"
        x2="67.7051"
        y2="2.41"
        id="eaf-2661-6"
      >
        <stop stopColor="#fff0" offset="0.0037" />
        <stop stopColor="#fffc" offset="0.9963" />
      </linearGradient>
      <linearGradient gradientUnits="userSpaceOnUse" x1="53.5" y1="29" x2="130.002" y2="28.75" id="eaf-2661-7">
        <stop stopColor="#8486ff" offset="0" />
        <stop stopColor="#a5c3ff" offset="0.27" />
        <stop stopColor="#a5c3ff" offset="0.69" />
        <stop stopColor="#0003d3" offset="1" />
      </linearGradient>
      <radialGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-0.9643 -0.2648 0.3844 -1.3997 121.8284 85.0655)"
        cx="67.5"
        cy="28"
        r="18.8827"
        fx="67.5"
        fy="28"
        fr="0"
        id="eaf-2661-8"
      >
        <stop stopColor="#0000" offset="0" />
        <stop stopColor="#160738" offset="1" />
      </radialGradient>
      <linearGradient gradientUnits="userSpaceOnUse" x1="5" y1="28" x2="130" y2="28" id="eaf-2661-9">
        <stop stopColor="#0000" offset="0" />
        <stop stopColor="#12086b" offset="1" />
      </linearGradient>
      <radialGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0 -1 11.5533 0 -336.365 103)"
        cx="68"
        cy="35"
        r="14"
        fx="68"
        fy="35"
        fr="0"
        id="eaf-2661-10"
      >
        <stop stopColor="#fff0" offset="0.455" />
        <stop stopColor="#fff" offset="1" />
      </radialGradient>
      <radialGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0.9988 0.0493 -0.0152 0.3073 0.5089 20.9787)"
        cx="21.5"
        cy="31.8141"
        r="24.0292"
        fx="21.5"
        fy="31.8141"
        fr="0"
        id="eaf-2661-11"
      >
        <stop stopColor="#00011b00" offset="0" />
        <stop stopColor="#000381" offset="1" />
      </radialGradient>
      <clipPath id="eaf-2661-12">
        <path
          d="m0 0l128.8026 0l0 -32.5l-128.8026 0l0 32.5z"
          clipRule="evenodd"
          transform="translate(3.3096 32.5)"
        />
      </clipPath>
    </defs>
    <g
      clipPath="url('#eaf-2661-1')"
      style={{
        isolation: 'isolate',
      }}
    >
      <g>
        <path
          fill="url('#eaf-2661-2')"
          d="m122.303 0l-111.1299 0c-0.4533 0 -0.85 0.3574 -1.02 0.9827l-9.9739 31.2655c-0.5667 1.7866 0.2833 3.7518 1.5301 3.7518l129.6037 0c1.247 0 2.04 -2.0546 1.53 -3.7518l-9.577 -31.1762c-0.113 -0.6253 -0.567 -1.072 -0.963 -1.072z"
          transform="translate(1.0001 0)"
        />
        <g transform="translate(-0.1122 1.75)" clipPath="url('#eaf-2661-12')">
          <g>
            <g>
              <path
                fill="url('#eaf-2661-3')"
                d="m5 26l125 0c0 0 -4.376 -15.1634 -7 -21.7013c-1.018 -2.4844 -3.438 -3.2987 -5.688 -3.2987l-99.4127 0c-2.2496 0 -4.4352 0.2645 -5.3993 2.7489c-2.6246 6.4726 -7.5 22.2511 -7.5 22.2511z"
              />
              <path
                fill="url('#eaf-2661-4')"
                fillOpacity="0.4"
                d="m5 26l125 0c0 0 -4.376 -15.1634 -7 -21.7013c-1.018 -2.4844 -3.438 -3.2987 -5.688 -3.2987l-99.4127 0c-2.2496 0 -4.4352 0.2645 -5.3993 2.7489c-2.6246 6.4726 -7.5 22.2511 -7.5 22.2511z"
              />
            </g>
            <path
              fill="none"
              stroke="url('#eaf-2661-5')"
              strokeLinejoin="bevel"
              d="m5.6789 25.5c0.0043 -0.0137 0.0086 -0.0277 0.013 -0.0418c0.1383 -0.4437 0.3388 -1.0848 0.5877 -1.8744c0.4978 -1.5794 1.1887 -3.7524 1.9616 -6.1274c1.5477 -4.7559 3.4175 -10.3022 4.7222 -13.5196l0 0l0.0027 -0.007c0.4302 -1.1086 1.1132 -1.6954 1.9361 -2.0223c0.8529 -0.3389 1.8784 -0.4075 2.9971 -0.4075l99.4127 0c2.152 0 4.317 0.7732 5.225 2.9869c1.303 3.2473 3.047 8.6525 4.469 13.2616c0.711 2.3018 1.339 4.3996 1.79 5.922c0.225 0.7612 0.406 1.3785 0.531 1.8053c0.002 0.0081 0.005 0.0162 0.007 0.0242l-123.6551 0z"
            />
            <g>
              <foreignObject x={-4} y={isSafari ? 2 : 3} width="100%" height="100%">
                <div
                  className="font-Bangers text-white text-sm tracking-[1.3px] font-medium"
                >
                  x
                  {multiplier}
                </div>
              </foreignObject>
              {/* <path */}
              {/*  fill="#fff" */}
              {/*  d="m59.276 17.0619c-0.0093 -0.1867 -0.0233 -0.3687 -0.042 -0.546c-0.0093 -0.1867 -0.0187 -0.3687 -0.028 -0.546c-0.0093 -0.1587 -0.0187 -0.3127 -0.028 -0.462c-0.0093 -0.1587 -0.0187 -0.3127 -0.028 -0.462c-0.0093 -0.1587 -0.0187 -0.2987 -0.028 -0.42c-0.0093 -0.1307 -0.0187 -0.2474 -0.028 -0.35l-0.322 0.77c-0.0653 0.1493 -0.1353 0.3033 -0.21 0.462c-0.0653 0.1493 -0.1307 0.2986 -0.196 0.448c-0.0747 0.1773 -0.154 0.3546 -0.238 0.532c-0.084 0.168 -0.168 0.3406 -0.252 0.518l-2.38 -0.21c0.2333 -0.4107 0.4667 -0.8214 0.7 -1.232c0.2333 -0.42 0.4667 -0.8307 0.7 -1.232c0.2333 -0.4107 0.4573 -0.826 0.672 -1.246c0.2147 -0.4294 0.42 -0.8634 0.616 -1.302c-0.056 -0.42 -0.112 -0.7934 -0.168 -1.12c-0.0467 -0.3267 -0.1027 -0.6487 -0.168 -0.966c-0.0653 -0.2987 -0.1353 -0.6207 -0.21 -0.966c-0.0747 -0.3547 -0.1493 -0.7187 -0.224 -1.092l2.24 -0.924c0.0467 0.448 0.1027 0.9333 0.168 1.456c0.028 0.2613 0.056 0.518 0.084 0.77c0.028 0.2427 0.0513 0.476 0.07 0.7l0.644 -1.4c0.1027 -0.2333 0.2053 -0.462 0.308 -0.686c0.112 -0.2333 0.224 -0.4667 0.336 -0.7l2.03 0.546c-0.3267 0.5507 -0.616 1.05 -0.868 1.498c-0.2427 0.448 -0.476 0.9007 -0.7 1.358c-0.224 0.4573 -0.476 0.98 -0.756 1.568c0.1027 0.7093 0.252 1.4606 0.448 2.254c0.196 0.7933 0.378 1.526 0.546 2.198c-0.0187 0.0093 -0.1307 0.042 -0.336 0.098c-0.2053 0.0466 -0.4807 0.1213 -0.826 0.224c-0.336 0.0933 -0.644 0.182 -0.924 0.266c-0.2707 0.0746 -0.4713 0.14 -0.602 0.196zm5.5739 -0.07c-0.7094 0 -1.2647 -0.2287 -1.666 -0.686c-0.4014 -0.4574 -0.602 -1.0594 -0.602 -1.806c0 -0.1774 0.0046 -0.364 0.014 -0.56c0.0186 -0.196 0.0373 -0.4014 0.056 -0.616l2.156 0.168c-0.0467 0.1586 -0.07 0.2706 -0.07 0.336c0 0.1866 0.056 0.322 0.168 0.406c0.112 0.084 0.2426 0.126 0.392 0.126c0.2613 0 0.504 -0.112 0.728 -0.336c0.2333 -0.224 0.35 -0.5554 0.35 -0.994c0 -0.2427 -0.098 -0.448 -0.294 -0.616c-0.1867 -0.168 -0.5834 -0.252 -1.19 -0.252c-0.1027 0 -0.2194 0.0046 -0.35 0.014c-0.1214 0.0093 -0.3034 0.0326 -0.546 0.07c-0.2427 0.028 -0.5974 0.084 -1.064 0.168c0.1026 -0.7 0.2286 -1.5027 0.378 -2.408c0.1493 -0.9147 0.3313 -1.946 0.546 -3.094l5.334 -0.196l-0.28 2.282c-0.2614 0.0093 -0.5227 0.0187 -0.784 0.028c-0.2614 0.0093 -0.5274 0.0187 -0.798 0.028c-0.2707 0.0093 -0.546 0.0187 -0.826 0.028c-0.2707 0.0093 -0.546 0.0233 -0.826 0.042l-0.14 1.176c0.5973 0 1.106 0.056 1.526 0.168c0.42 0.112 0.7606 0.266 1.022 0.462c0.2613 0.196 0.448 0.4293 0.56 0.7c0.1213 0.2613 0.182 0.5553 0.182 0.882c0 0.4573 -0.1167 0.952 -0.35 1.484c-0.224 0.5226 -0.5414 1.0173 -0.952 1.484c-0.42 0.476 -0.8634 0.8493 -1.33 1.12c-0.4667 0.2613 -0.9147 0.392 -1.344 0.392z" */}
              {/* /> */}
            </g>
            <path
              fill="#fff"
              d="m73.3553 12.3545l5.5986 -6.0568c0.376 -0.4213 1.0785 -0.1593 1.0785 0.402l-0.8001 4.1721c0 0.3367 0.276 0.6087 0.6161 0.6087l2.3344 0c0.5305 0 0.8129 0.618 0.4625 1.012l-4.7986 6.0561c-0.376 0.4214 -1.0785 0.1594 -1.0785 -0.402l0.8001 -4.1721c0 -0.3366 -0.276 -0.6086 -0.6161 -0.6086l-3.1353 0c-0.5304 0 -0.812 -0.618 -0.4616 -1.0114z"
            />
            <path
              fill="url('#eaf-2661-6')"
              d="m11.9442 10.5985c0.7618 -1.7298 1.3059 -3.373 2.4486 -4.3243c0.8706 -0.6919 1.85 -1.0378 2.8839 -1.0378l100.5013 0c2.775 0 5.06 3.4595 6.311 7.0054c0.273 0.7784 0.599 1.6433 0.925 2.6811c-0.653 -2.1622 -1.305 -4.0649 -1.795 -5.5351c-1.469 -4.4973 -2.666 -6.7459 -6.203 -6.9189l-98.9231 0c-1.4692 0 -1.9045 0.0865 -2.8839 0.7784c-1.1971 0.8649 -1.9589 2.9405 -2.6663 4.6703c-0.7618 1.9027 -2.0677 6.4 -2.1765 6.7459c0.4897 -1.1243 1.0339 -2.854 1.578 -4.0648z"
              opacity="0.6"
            />
            <path
              fill="url('#eaf-2661-7')"
              d="m6.25 23.5l122.5 0c0.414 0 0.75 0.3358 0.75 0.75l0 4.6066c0 0.0572 -0.007 0.1142 -0.019 0.1698l-0.673 2.8935c-0.079 0.3397 -0.382 0.5801 -0.731 0.5801l-121.113 0c-0.3452 0 -0.6458 -0.2356 -0.7283 -0.5708l-0.714 -2.9015c-0.0144 -0.0587 -0.0217 -0.1188 -0.0217 -0.1792l0 -4.5985c0 -0.4142 0.3358 -0.75 0.75 -0.75z"
            />
            <path
              fill="url('#eaf-2661-8')"
              fillOpacity="0.4"
              d="m6.25 23.5l122.5 0c0.414 0 0.75 0.3358 0.75 0.75l0 4.6066c0 0.0572 -0.007 0.1142 -0.019 0.1698l-0.673 2.8935c-0.079 0.3397 -0.382 0.5801 -0.731 0.5801l-121.113 0c-0.3452 0 -0.6458 -0.2356 -0.7283 -0.5708l-0.714 -2.9015c-0.0144 -0.0587 -0.0217 -0.1188 -0.0217 -0.1792l0 -4.5985c0 -0.4142 0.3358 -0.75 0.75 -0.75z"
            />
            <path
              fill="url('#eaf-2661-9')"
              fillOpacity="0.2"
              d="m6.25 23.5l122.5 0c0.414 0 0.75 0.3358 0.75 0.75l0 4.6066c0 0.0572 -0.007 0.1142 -0.019 0.1698l-0.673 2.8935c-0.079 0.3397 -0.382 0.5801 -0.731 0.5801l-121.113 0c-0.3452 0 -0.6458 -0.2356 -0.7283 -0.5708l-0.714 -2.9015c-0.0144 -0.0587 -0.0217 -0.1188 -0.0217 -0.1792l0 -4.5985c0 -0.4142 0.3358 -0.75 0.75 -0.75z"
            />
            <path
              fill="none"
              stroke="url('#eaf-2661-10')"
              strokeLinejoin="round"
              d="m6.25 23.5l122.5 0c0.414 0 0.75 0.3358 0.75 0.75l0 4.6066c0 0.0572 -0.007 0.1142 -0.019 0.1698l-0.673 2.8935c-0.079 0.3397 -0.382 0.5801 -0.731 0.5801l-121.113 0c-0.3452 0 -0.6458 -0.2356 -0.7283 -0.5708l-0.714 -2.9015c-0.0144 -0.0587 -0.0217 -0.1188 -0.0217 -0.1792l0 -4.5985c0 -0.4142 0.3358 -0.75 0.75 -0.75z"
            />
            <g>
              <path
                fill="url('#eaf-2661-11')"
                fillOpacity="0.4"
                d="m4 30.6289l127 0l-0.742 1.7591c-0.156 0.3704 -0.519 0.6113 -0.921 0.6113l-123.6735 0c-0.4021 0 -0.7651 -0.2409 -0.9214 -0.6113l-0.7421 -1.7591z"
                transform="matrix(0.9737 0 0 1 1.7784 0)"
              />
            </g>
            <animateTransform
              id="bnt-animation-1"
              attributeName="transform"
              type="translate"
              from="0 0"
              to="0 0"
              calcMode="discrete"
              dur="1000ms"
              repeatCount="indefinite"
              fill="remove"
              begin="click"
            />
            <animateMotion
              id="bnt-animation-2"
              keyTimes="0;0.5;1"
              calcMode="spline"
              keySplines="0.88 0.008 0.14 0.993;0.88 0.008 0.14 0.993"
              dur="1000ms"
              repeatCount="indefinite"
              attributeName="transform"
              keyPoints="0;0.5;1"
              path="m67.5 16.9996l0 8.4696l0 -8.4696"
              additive="sum"
              fill="remove"
              begin="click"
            />
            <animateTransform
              id="bnt-animation-3"
              attributeName="transform"
              type="translate"
              from="-67.5 -16.9996"
              to="-67.5 -16.9996"
              calcMode="discrete"
              dur="1000ms"
              repeatCount="indefinite"
              additive="sum"
              fill="remove"
              begin="click"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
));
BottomScreenSVG.displayName = 'BottomScreenSVG';
